import { BUSINESS } from "@/data/salonData";

/**
 * Build a wa.me URL that opens WhatsApp with a pre-filled message
 * to Anshi's phone number. Works on mobile + desktop web.
 */
export function buildWhatsAppLink(message) {
  const encoded = encodeURIComponent(message || "Hello Anshi's Makeover!");
  return `https://wa.me/${BUSINESS.phoneIntl}?text=${encoded}`;
}

export function openWhatsApp(message) {
  const url = buildWhatsAppLink(message);
  window.open(url, "_blank", "noopener,noreferrer");
}

export function bookServiceMessage(serviceName, price) {
  const priceLine = price ? `\nPrice: ₹${price}` : "";
  return `Hello Anshi's Makeover,

I would like to book an appointment.

Service: ${serviceName}${priceLine}

Please confirm my appointment.`;
}

export function buildAppointmentMessage({
  name,
  phone,
  service,
  date,
  time,
  message,
}) {
  return `Hello Anshi's Makeover,

*Appointment Request*

Name: ${name || "-"}
Phone: ${phone || "-"}
Service: ${service || "-"}
Preferred Date: ${date || "-"}
Preferred Time: ${time || "-"}
Message: ${message || "-"}

Please confirm my appointment.`;
}
